<script setup lang="ts">
defineProps<{ loading?: boolean; error?: string; empty?: boolean; emptyText?: string }>();
defineEmits<{ retry: [] }>();
</script>
<template>
  <div v-if="error" class="load-state load-state-error" role="alert"><div><strong>暂时未能更新</strong><p>{{ error }}</p><small>已有内容如仍显示，来自上次成功加载。</small></div><button class="command-button secondary" type="button" :disabled="loading" @click="$emit('retry')">{{ loading ? '正在重试…' : '重试' }}</button><RouterLink to="/login" v-if="error.includes('登录')" class="text-link">重新登录</RouterLink></div>
  <div v-else-if="loading" class="load-state" role="status" aria-live="polite">正在读取数据，请稍候…</div>
  <div v-else-if="empty" class="load-state" role="status"><div><strong>{{ emptyText || '暂无数据' }}</strong><p><slot /></p></div></div>
</template>
